module.exports = __webpack_public_path__ + "static/media/lider-logistica.e4534c91.jpg";